<template>
	<v-container fluid>
		<div class="bottom-buttons-outer">
			<v-btn color="success" @click="backClick">
				<v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
			</v-btn>
			<v-btn color="success" @click="saveClick">
				<v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
			</v-btn>
		</div>
		<v-layout row wrap>
			<v-flex md4 xs10 offset-md1>
				<span style="display:inline-block; padding:10px; margin-top:5px; color:grey; font-size:15px;"><b>{{$t('labels.codebooksHeating')}}</b></span><br><br>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex md5 xs12 offset-md1>
				<table class="table">
					<tr>
						<th width="80%">Vrijednost</th>
						<th width="20%">&nbsp;</th>
					</tr>
					<tr v-for="(item,key) in this.entries" :key="key">
						<td width="80%">{{item.value}}</td>
						<td width="20%">
							<v-tooltip right>
								<v-btn @click="removeEntry(key)" icon slot="activator">
									<v-icon small color="grey darken-3">fa-trash fa-lg</v-icon>
								</v-btn>
							<span>{{$t('tooltips.delete')}}</span>
							</v-tooltip>
						</td>
					</tr>
				</table>
			</v-flex>
		</v-layout>
		<v-layout row wrap pb-5>
			<v-flex md4 xs11 offset-md1 pl-2>
				<InputField
					v-model="newEntry"
					:simple="true"
					@keyup.native.enter="addEntry"></InputField>
			</v-flex>
			<v-flex md1 xs1 text-md-right text-xs-right>
				<v-tooltip right>
					<v-btn @click="addEntry" icon slot="activator">
						<v-icon small color="grey darken-3">fa-plus fa-lg</v-icon>
					</v-btn>
				<span>{{$t('tooltips.add')}}</span>
				</v-tooltip>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			&nbsp;
		</v-layout>
	</v-container>
</template>

<script>
import InputField from "./trinkets/InputField";

export default {
	name: "codebooksHeating",
	components: {InputField},
	data: function () {
		return {
			entries: [],
			newEntry: ''
		}
	},
	methods: {
		backClick(){
			this.$router.push('/codebooks/');
		},
		saveClick(){
				let vm = this;
				this.$APICall('put', 'codebooks/heating', this.entries, (data, success) => {
					if (success) {
						vm.$notify(vm.$t('alerts.basicUpdate'));
						vm.backClick();
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
		},
		removeEntry(key){
			this.$verify(this.$t('alerts.removalQuestion'), (result) => {
				if (result) {
					this.entries.splice(key, 1);
				}
			});
		},
		addEntry(){
			if(this.newEntry != null && this.newEntry != ''){
				let newObject= {
					label: this.newEntry,
					value: this.newEntry
				}
				this.entries.push(newObject);
				this.newEntry = '';
				this.$nextTick(function(){
					window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
				});
			}
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$setSubMenu('Settings');
		this.$myStore.commit('setBreadcrumbs', [
			{text: this.$t('modules.codebooks'), href: '/#/codebooks', disabled: false},
			{text: this.$t('labels.codebooksHeating'), href: '/#/codebooks', disabled: true},
		]);
		let vm = this;
			this.$APICall('get', 'codebooks/heating', null, (data, success) => {
			if (success) {
				vm.entries = data;
			} else {
				vm.$alert(vm.$t('alerts.basicError'));
			}
		});
	}
}
</script>

<style scoped>
.table{
	font-family: Helvetica, sans-serif;
    font-size: 14px;
    border-collapse: collapse;
	width: 100%;
	border-radius: 6px;
    text-align:right;
	overflow: hidden;
	color: rgb(34, 34, 34);
}

.table td, .table th{
    padding-left:10px;
}

.table th{
    font-size: 15px;
    font-weight: bold;
    padding-top: 5px;
    padding-bottom: 5px;
    background-color: #cacaca;
	opacity: 0.9;
}

.table tr:nth-child(even){
    background-color: #e8e8e8;
}

.table th:first-child, table td:first-child{
    text-align: left;
}

.table tr:hover{
    background-color: #ddd;
}
</style>
